import { render, staticRenderFns } from "./delete-prompt-modal.vue?vue&type=template&id=769b122c&scoped=true"
import script from "./delete-prompt-modal.vue?vue&type=script&lang=js"
export * from "./delete-prompt-modal.vue?vue&type=script&lang=js"
import style0 from "./delete-prompt-modal.vue?vue&type=style&index=0&id=769b122c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "769b122c",
  null
  
)

export default component.exports